import { EmbedType, LoomUrl, ParsedUrl, YoutubeUrl } from './types';
import { isNil } from 'lodash';
import { MaybeNil } from '../../utils/interfaces';

const tryYoutube = (url: URL): MaybeNil<YoutubeUrl> => {
  let videoId = null;
  if (url.host === 'youtube.com' || url.host === 'www.youtube.com') {
    videoId = url.searchParams.get('v');
  } else if (url.host === 'youtu.be') {
    const pathSegments = url.pathname.split('/');
    if (pathSegments.length > 1) {
      // there is a leading slash
      videoId = pathSegments[1];
    }
  }

  // video ID is expected to be 11 characters long:
  // https://developers.google.com/youtube/iframe_api_reference
  if (!isNil(videoId) && videoId.length === 11) {
    return {
      type: EmbedType.Youtube,
      url: url.toString(),
      videoId,
    };
  }

  return null;
};

const loomIdPattern = /^\w+$/;

const tryLoom = (url: URL): MaybeNil<LoomUrl> => {
  let videoId = null;
  if (url.host === 'www.loom.com' || url.host === 'loom.com') {
    const pathSegments = url.pathname.split('/');
    if (pathSegments.length > 2) {
      // there is a leading slash
      const type = pathSegments[1].toLowerCase();
      if (type === 'share' || type === 'embed') {
        videoId = pathSegments[2];
      }
    }
  }

  if (!isNil(videoId) && videoId.match(loomIdPattern)) {
    return {
      type: EmbedType.Loom,
      url: url.toString(),
      videoId,
    };
  }

  return null;
};

export const parseEmbedUrl = (urlStr: string): ParsedUrl => {
  let url;
  try {
    url = new URL(urlStr);
  } catch (e) {
    console.warn(`Failed to parse URL [${urlStr}]`, e);
    return {
      type: EmbedType.Unsupported,
      url: urlStr,
    };
  }

  const maybeYoutube = tryYoutube(url);
  if (!isNil(maybeYoutube)) {
    return maybeYoutube;
  }

  const maybeLoom = tryLoom(url);
  if (!isNil(maybeLoom)) {
    return maybeLoom;
  }

  return {
    type: EmbedType.Unsupported,
    url: urlStr,
  };
};
